class InternalServerError extends Error {
    constructor(cause?: Error) {
        super("El recurso presenta un error interno", {
            cause,
        });
    }
}

export { InternalServerError };
